import styled from 'styled-components';

export default (Component) => styled(Component)`
  padding: 40px 30px;
  text-align: justify;
  text-justify: inter-word;
  color: #1E3C81;
  .title {
    border: 1px solid #1E3C81;
    padding: 20px;
    text-align: left;
    text-transform: uppercase;
    font-size: 25px;
    line-height: 30px;
  }
  h2 {
    color: #06152D;
    margin: 25px 0 10px;
  }
`;